__webpack_require__.p = "https://cdn.dgtalguide.com/web/bundles/cb8f86d/";